import { Link, useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { useStore } from "../store/StoreContext";
import { img } from "../lib/format";
import SEO from "../components/SEO";
import WordReveal from "../components/WordReveal";
import EnquiryQuantity from "../components/EnquiryQuantity";
import CatalogueDetails from "../components/CatalogueDetails";

export default function Cart() {
  const { cartDetailed, setQty, removeFromCart } = useStore();
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-[1300px] px-4 sm:px-8 pt-8 sm:pt-12 pb-28" data-testid="enquiry-basket-page">
      <SEO title="Your Enquiry — S H & SONS ®" description="Review the designs selected for your international sourcing enquiry." />
      <WordReveal as="h1" text="Your Enquiry" className="h-display text-center text-6xl sm:text-7xl lg:text-[112px]" />
      {cartDetailed.length === 0 ? (
        <div className="py-24 text-center">
          <p className="text-2xl font-light text-charcoal">Your enquiry selection is currently empty.</p>
          <Link to="/shop" className="pill-dark mt-8 px-8">Discover the Collection</Link>
          <Link to="/catalogue" className="block mt-5 text-[12px] text-mocha underline underline-offset-4">Request the export catalogue</Link>
        </div>
      ) : (
        <div className="mt-14 grid lg:grid-cols-[1fr_380px] gap-12 lg:gap-16">
          <div className="space-y-8">
            {cartDetailed.map(({ product, qty }) => (
              <div key={product.slug} className="flex gap-5 sm:gap-8 pb-8 border-b border-line" data-testid={"enquiry-item-" + product.slug}>
                <Link to={"/product/" + product.slug} className="w-24 sm:w-36 aspect-square bg-cream rounded-[22px] shrink-0 overflow-hidden flex items-center justify-center h-fit">
                  <img src={img(product.images[0])} alt={product.name} className="w-full h-full object-contain p-3" />
                </Link>
                <div className="flex-1 min-w-0 flex flex-col">
                  <div className="flex justify-between gap-4">
                    <div>
                      <Link to={"/product/" + product.slug} className="text-[20px] font-light hover:text-brass transition-colors duration-200">{product.name}</Link>
                      <CatalogueDetails product={product} className="mt-1" />
                    </div>
                    <button onClick={() => removeFromCart(product.slug)} aria-label={"Remove " + product.name} className="text-mocha hover:text-ink transition-colors duration-200 h-fit p-2 -mr-2">
                      <Trash2 className="w-4 h-4" strokeWidth={1.5} />
                    </button>
                  </div>
                  <div className="mt-auto pt-4">
                    <EnquiryQuantity value={qty} onChange={(value) => setQty(product.slug, value)} id={"basket-quantity-" + product.slug} compact />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <aside className="bg-cream rounded-[28px] p-7 sm:p-9 h-fit lg:sticky lg:top-28" data-testid="enquiry-summary">
            <h2 className="text-[22px] font-light mb-6">Your selection</h2>
            <p className="text-[14px] text-charcoal">{cartDetailed.length} {cartDetailed.length === 1 ? "design" : "designs"} selected</p>
            <p className="mt-4 text-[13px] text-mocha leading-relaxed">Share your market, preferred finishes and project requirements. Approximate quantities are optional and will be confirmed with our team.</p>
            <button onClick={() => navigate("/enquiry")} className="pill-dark w-full mt-6 py-4 uppercase tracking-[0.2em] text-[11px]" data-testid="basket-enquiry-button">Continue to enquiry</button>
            <Link to="/shop" className="mt-4 block text-center text-[11px] uppercase tracking-[0.2em] text-mocha hover:text-ink transition-colors duration-200">Explore more designs</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
